import { render, staticRenderFns } from "./inventory-status.vue?vue&type=template&id=bb75bb64&scoped=true&"
import script from "./inventory-status.vue?vue&type=script&lang=js&"
export * from "./inventory-status.vue?vue&type=script&lang=js&"
import style0 from "./inventory-status.vue?vue&type=style&index=0&id=bb75bb64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb75bb64",
  null
  
)

export default component.exports